import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const DATASOURCE: AppRouteRecordRaw = {
  path: '/datasource',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '数据源管理',
    icon: 'icon-settings',
    order: 10
  },
  children: [
    {
      path: 'list',
      component: () => {
        return import('@/views/datasource/list/page.vue');
      },
      meta: {
        locale: '数据源列表',
        icon: 'icon-folder'
      }
    }
  ]
};

export default DATASOURCE;
